import { create } from 'zustand';
import api from '@/api/api';
import { showToast } from '@/components/ToastManager';
import { DataPublishOptions } from 'livekit-client';
import { combine } from 'zustand/middleware';

type SendFunction = (payload: Uint8Array, options: DataPublishOptions) => void;

interface StudyModeState {
  isPracticeMode: boolean;
  send: SendFunction | null;
}

interface StudyModeActions {
  setIsPracticeMode: (isPracticeMode: boolean) => void;
  setSend: (send: SendFunction | null) => void;
  toggleStudyMode: (meetingUid: string) => Promise<void>;
  setStudyMode: (meetingUid: string) => Promise<void>;
}

export const useStudyModeStore = create(
  combine<StudyModeState, StudyModeActions>(
    {
      isPracticeMode: false,
      send: null
    },
    (set, get) => ({
      setIsPracticeMode: (isPracticeMode) => set({ isPracticeMode }),
      setSend: (send) => set({ send }),
      toggleStudyMode: async (meetingUid: string) => {
        const { isPracticeMode, send } = get();
        if (!send) {
          console.error('Data channel send function is not available.');
          return;
        }
        const newMode = !isPracticeMode;
        set({ isPracticeMode: newMode });

        try {
          await api.changeStudyMode(meetingUid);
          const message = JSON.stringify({ isPracticeMode: newMode });
          send(new TextEncoder().encode(message), { reliable: true });
        } catch (error) {
          console.error('Failed to toggle study mode:', error);
          showToast('errorToast', 'error', 'Ошибка при смене режима занятия');
          set({ isPracticeMode: !newMode });
        }
      },
      setStudyMode: async (meetingUid: string) => {
        try {
          const res = await api.getStudyMode(meetingUid);
          set({ isPracticeMode: res });
        } catch (error) {
          console.error('Failed to get initial study mode:', error);
        }
      }
    })
  )
);
